'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFormatColorReset = function MdFormatColorReset(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.8 8.8l24.3 24.3-2.1 2.1-4.4-4.3q-2.9 2.5-6.6 2.5-4.1 0-7.1-3t-2.9-7q0-2.7 2.2-6.9l-5.6-5.6z m21.2 14.6q0 1.1-0.2 2.1l-14.3-14.3 4.5-5.9q1.1 1.3 2.8 3.4t4.4 6.9 2.8 7.8z' })
        )
    );
};

exports.default = MdFormatColorReset;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/format-color-reset.js
// module id = 2360
// module chunks = 0